import { render, staticRenderFns } from "./ScrollToAnkerLink.vue?vue&type=template&id=a51c7afc"
import script from "./ScrollToAnkerLink.vue?vue&type=script&lang=js"
export * from "./ScrollToAnkerLink.vue?vue&type=script&lang=js"
import style0 from "./ScrollToAnkerLink.vue?vue&type=style&index=0&id=a51c7afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports